<!-- Brand area -->
<div class="h-18! flex items-center shrink-0 border-2! border-white/10"
     [class.px-pmdf-4]="layout.isSidenavExpanded()"
     [class.justify-center]="!layout.isSidenavExpanded()">
  @if (layout.isSidenavExpanded()) {
    <div class="flex flex-col leading-none">
      <span class="text-lg font-semibold tracking-wider text-white">SGP-PM</span>
      <span class="text-base font-light tracking-tighter text-white/60">Sistema de Gestão de Pessoal</span>
    </div>
  } @else {
    <span class="text-lg font-bold text-pmdf-warning">SGP</span>
  }
</div>

<nav class="flex flex-col flex-1 py-pmdf-2 overflow-y-auto overflow-x-hidden">
  @for (group of visibleGroups(); track group.category) {
    @if (layout.isSidenavExpanded()) {
      <div class="px-pmdf-4 pt-pmdf-4 pb-pmdf-2 opacity-40">
        <span class="text-xs uppercase tracking-widest font-semibold">
          {{ group.category }}
        </span>
      </div>
    } @else {
      <div class="my-pmdf-2 mx-pmdf-2 border-t border-white/10"></div>
    }

    <div class="flex flex-col gap-pmdf-1 px-pmdf-2">
      @for (item of group.items; track item.label) {
        @if (item.children) {
          <button (click)="toggleSubmenu(item.label)"
                  [matTooltip]="layout.isSidenavExpanded() ? '' : item.label"
                  matTooltipPosition="right"
                  [attr.aria-expanded]="isExpanded(item.label)"
                  class="flex items-center h-11 px-pmdf-3 rounded-pmdf-card text-white/70 hover:bg-white/10 hover:text-white transition-all duration-200 w-full text-left">
            <mat-icon class="shrink-0">{{ item.icon }}</mat-icon>
            @if (layout.isSidenavExpanded()) {
              <span class="ml-pmdf-3 font-base whitespace-nowrap overflow-hidden flex-1 text-base">{{ item.label }}</span>
              <mat-icon class="icon-sm transition-transform duration-200"
                        [class.rotate-90]="isExpanded(item.label)">
                chevron_right
              </mat-icon>
            }
          </button>

          @if (isExpanded(item.label) && layout.isSidenavExpanded()) {
            <div @expandCollapse class="flex flex-col gap-pmdf-1 ml-pmdf-4 pl-pmdf-3 border-l border-white/10">
              @for (child of item.children; track child.label) {
                @if (child.isHeader) {
                  <div class="px-pmdf-3 pt-pmdf-3 pb-pmdf-1 opacity-45 select-none">
                    <span class="text-[9px] uppercase tracking-[0.16em] font-bold text-white">{{ child.label }}</span>
                  </div>
                } @else {
                  <a [routerLink]="child.route"
                     [queryParams]="child.queryParams || {}"
                     routerLinkActive="active-menu-item"
                     [routerLinkActiveOptions]="{ exact: child.route === '/dashboard' || child.route === '/cadastro' }"
                     [matTooltip]="layout.isSidenavExpanded() ? '' : child.label"
                     matTooltipPosition="right"
                     class="flex items-center h-9 px-pmdf-3 rounded-pmdf-card text-white/60 hover:bg-white/10 hover:text-white transition-all duration-200 text-sm">
                    <mat-icon class="icon-lg shrink-0">{{ child.icon }}</mat-icon>
                    <span class="ml-pmdf-2 font-base whitespace-nowrap overflow-hidden text-base">{{ child.label }}</span>
                  </a>
                }
              }
            </div>
          }
        } @else {
          <a [routerLink]="item.route"
             [queryParams]="item.queryParams || {}"
             routerLinkActive="active-menu-item"
             [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }"
             [matTooltip]="layout.isSidenavExpanded() ? '' : item.label"
             matTooltipPosition="right"
             class="flex items-center h-11 px-pmdf-3 rounded-pmdf-card text-white/70 hover:bg-white/10 hover:text-white transition-all duration-200">
            <mat-icon class="shrink-0">{{ item.icon }}</mat-icon>
            @if (layout.isSidenavExpanded()) {
              <span class="ml-pmdf-3 font-base whitespace-nowrap overflow-hidden text-base">{{ item.label }}</span>
            }
          </a>
        }
      }
    </div>
  }
</nav>
